import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDocumentTypesList } from '../../../redux/common/CommonActions';
import { getDocumentTypesEffect } from '../../../redux/common/CommonEffects';
import FormSelectBox from '../Inputs/FormSelectBox';

const DocumentTypeSelector = ({
  placeholder = i18n.t('translation:default.documentManager.documentManager.placeholder'),
  label = i18n.t('translation:default.documentManager.documentManager.label'),
  rules = [],
  name,
  editMode,
  moduleId = false,
  onChange,
  disabled,
  disableValidation = false,
  dataTestId = 'document-type-selector',
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { documentTypesList } = useSelector((state) => state.common);

  const docTypeOptions = documentTypesList.data.map((row) => ({
    label: row.description,
    value: row.docTypeCode,
  }));
  // extract only options with uniq key accessor
  const selectOptions = Array.from(new Map(docTypeOptions.map((item) => [item.value, item])).values());

  useEffect(() => {
    if (!documentTypesList.success && moduleId) getStatusList();
  }, [documentTypesList.success]);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } = await getDocumentTypesEffect({ moduleId });
      dispatch(setDocumentTypesList({ data, success: true }));
      setLoading(false);
    } catch {
      dispatch(setDocumentTypesList({ data: [], success: false }));
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={selectOptions}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      disabled={disabled}
      disableValidation={disableValidation}
      dataTestId={dataTestId}
    />
  );
};

export default DocumentTypeSelector;
